import { render, staticRenderFns } from "./UpdateBloodCompatibility.vue?vue&type=template&id=61776093&scoped=true"
import script from "./UpdateBloodCompatibility.vue?vue&type=script&lang=js"
export * from "./UpdateBloodCompatibility.vue?vue&type=script&lang=js"
import style0 from "./UpdateBloodCompatibility.vue?vue&type=style&index=0&id=61776093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61776093",
  null
  
)

export default component.exports